<template>
  <v-content>
    <v-container fluid>
      <v-row v-if='currentUser.roles.includes(1)'>
        <v-col cols='12' md='5' sm='12'>
          <v-autocomplete
              v-model="selectedCourses"
              :items="courses"
              item-value="course_id"
              item-text="course_name"
              :label="'Courses' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
            ></v-autocomplete>
        </v-col>
        <v-col cols='12' md='5' sm='12'>
          <v-autocomplete
              v-model="selectedUsers"
              :items="users"
              item-value="user_id"
              item-text="name"
              :label="'Users' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
            ></v-autocomplete>
        </v-col>        
        <v-col cols='12' md='2' sm='12'>
          <v-btn class="white--text" small :color="primary_color" @click="getDashboardData()"  x-large block>
            <v-icon>mdi-search</v-icon>{{ 'Search' | translate }}
          </v-btn>              
        </v-col>
      </v-row>      
      <template v-if="coursesdata.length >0">
      <v-row v-for="(courses, courseindex) of coursesdata" :key="courseindex">
        <v-col cols="12" sm="12" md="12" class="pt-0">
              <h3 class="mb-5">{{ courses.course_name }}</h3>
              <v-expansion-panels v-model="openedDocumentPanel[courses.course_id]">
                <v-expansion-panel class="mb-5">
                <v-expansion-panel-header @click="openDocumentPanel('search'+courses.course_id,courses.course_id)">
                  {{ 'Documents' | translate }}
                  </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="6" offset-md="6">
                      <v-text-field
                        outlined
                        autocomplete="off"
                        :label="'Search documents' | translate"
                        :ref="'search'+courses.course_id"
                        @keyup="openDocumentPanel('search'+courses.course_id,courses.course_id)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-sheet
                    class="mx-auto"
                    v-if="(dashboarddocuments.hasOwnProperty(courses.course_id) ? (dashboarddocuments[courses.course_id].length >0 ? true : (loadingdata ==false ? true : false) ): false )"
                  >
                    <v-slide-group
                      class="pa-4"
                      show-arrows
                    >
                      <v-slide-item
                        v-for="(documentdata,documentindex) of dashboarddocuments[courses.course_id]" 
                        :key="documentindex+''+documentdata.gendoc_id+''+documentdata.course_id"
                      >
                        <v-card
                          class="ma-4 pa-1"
                          width="200"
                        >
                          <v-row>
                            <v-col cols="12"
                              class="fill-height"
                              align="center"
                              justify="center">
                            <v-icon
                              size="60"
                              v-text="'mdi-file-document'"
                            ></v-icon>
                            </v-col>
                          </v-row>
                          <v-card-title class="text-center">{{ documentdata.gendoc_name }}</v-card-title>
                          <v-card-text>
                            {{documentdata.gendoc_description}}
                          </v-card-text>
                          <v-card-text class="text-center">
                              <v-btn class="white--text" :color="primary_color" target="_blank" small :to="'/documents/'+documentdata.hash_id">{{ 'Details' | translate}}</v-btn>
                          </v-card-text>
                        </v-card>
                      </v-slide-item>
                    </v-slide-group>
                  </v-sheet>
                  <h3 v-else>{{ 'No data found' | translate }}</h3>
                </v-expansion-panel-content>
                </v-expansion-panel>                
              </v-expansion-panels>

              <v-expansion-panels  v-model="openedPanel[courseindex]" multiple accordion>
                <v-expansion-panel v-for="(moduledata,moduleindex) of courses.company_modules" expandable :key="courseindex+''+moduleindex"   :value="moduleindex"  class="mb-5">
                <v-expansion-panel-header class="pa-0">
                  <v-row>
                    <v-col cols="4" md="2" class="pt-9 text-center username" v-if="moduledata.hasOwnProperty('user_name')" v-on:click.stop="getTime(courseindex,moduleindex,moduledata.module_id,courses.course_id, (moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))">{{ moduledata.user_name }}</v-col>
                    <v-col cols="4" md="2" class="pt-9 text-center play-button" v-else v-on:click.stop="play(moduledata.module_id)"><v-icon color="success" class="mt-n1">mdi-play-circle</v-icon>{{ 'Play' | translate }}</v-col>
                    <v-col cols="12" md="6" class="pt-9  module-title" v-on:click.stop="getTime(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''), 'to'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))">{{ moduledata.title }}</v-col>
                    <v-col cols="4" md="2" class="pt-7 pb-7 text-center timespent" v-bind:style="{'background-color':'#f7f7f7'}"     v-on:click.stop="getTime(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''), 'to'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))"><h4 class="pb-2">{{ 'Time Spent' | translate }}</h4>{{ moduledata.time_spent }}</v-col>
                    <v-col cols="4" md="2" class="pt-9 text-center progress" v-bind:style="{'background-color':primary_color}" v-on:click.stop="getQuizData(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))">
                      <v-progress-circular
                        :rotate="360"
                        :size="40"
                        :width="4"
                        class="mt-n3 mb-n3"
                        :value="moduledata.module_progress"
                        color="white"
                        v-if="moduledata.module_progress<100"
                      >
                        {{ moduledata.module_progress }}
                      </v-progress-circular>      
                      <v-icon
                        color="success"
                        size="35"
                        class="mt-n3 mb-n3"
                        v-text="'mdi-checkbox-marked-circle'"
                        v-else
                      ></v-icon>              
                    </v-col>
                  </v-row>
                <template v-slot:actions>
                  <v-col cols="3" md="3" class="pt-6 pb-6">
                    <v-icon v-on:click.stop="closePanel(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))">$expand</v-icon>
                  </v-col>
                </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content 
                v-bind:style=" 
                ( activeData.hasOwnProperty(courses.course_id) ? 
                (activeData[courses.course_id][moduleindex] == 'quiz' ? 
                 {'border':'4px solid '+primary_color} : 
                  {'background-color':'#f7f7f7'}):
                 '')      " >
                 <v-row v-if="timesessiondata.hasOwnProperty(courses.course_id)" class="pt-4 mb-n4">
                    <v-col cols="12" md="2" class="text-center">
                      <h3 class="mt-3">{{ ( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'Your sessions'  : 'Your attempts'  ):'') | translate }}</h3>
                    </v-col>
                    <v-col cols="12" md="3">
                          <v-text-field
                            :label="'From' | translate"
                            name="from"
                            type="date"
                            :ref="'from'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')"
                            autocomplete="off"
                            outlined
                          ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                          <v-text-field
                            :label="'To' | translate"
                            name="to"
                            type="date"
                            :ref="'to'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')"
                            autocomplete="off"
                            outlined
                            
                          ></v-text-field>
                    </v-col>  
                    <v-col cols="12" md="3" >
                        <v-btn class="mt-2  white--text"  :color="primary_color" @click="( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ?getTime(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')): getQuizData(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))):'')" >{{ 'Check' | translate}}</v-btn>
                        <v-btn class="mt-2 white--text"  :color="primary_color"  @click="( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ?clearTime(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')): clearQuizData(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+courses.course_id+moduledata.module_id+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))):'')">{{ 'Clear' | translate}}</v-btn>
                    </v-col>                     
                    <v-col cols="12" md="1" >
                    </v-col>                                      
                  </v-row> 
                  
                  <v-sheet
                    class="mx-auto"
                    style="'background-color':'#f7f7f7'"
                    v-if="(timesessiondata.hasOwnProperty(courses.course_id) ==true ?   timesessiondata[courses.course_id].hasOwnProperty(moduleindex) ==true ? timesessiondata[courses.course_id][moduleindex].length > 0  ? true : false : false : false )"
                  >
                    <v-slide-group
                      class="pa-4"
                      show-arrows
                v-bind:style=" 
                ( activeData.hasOwnProperty(courses.course_id) ? 
                (activeData[courses.course_id][moduleindex] == 'time' ? 
                  {'background-color':'#f7f7f7'}:''): 
                 '')      "

                    >
                      <v-slide-item
                        v-for="(time,timeindex) of timesessiondata[courses.course_id][moduleindex]"
                        :key="timeindex"
                      >
                        <v-card
                          class="ma-4 pa-2"
                          width="220"
                          v-if="time.hasOwnProperty('statement_query') == true"
                        >
                        <v-row
                          align="center"
                          justify="center"
                        >
                            <v-icon
                              color="success"
                              size="60"
                              class="pb-2"
                              v-text="'mdi-checkbox-marked-circle'"
                              v-if="time.statement_query == 'passed'"
                            ></v-icon>
                            <v-icon
                              color="yellow darken-1"
                              size="60"
                              class="pb-2"
                              v-text="'mdi-book'"
                              v-else-if="time.statement_query == 'attempted'"
                            ></v-icon>
                            <v-icon
                              color="red accent-3"
                              size="60"
                              class="pb-2"
                              v-text="'mdi-exclamation'"
                              v-else
                            ></v-icon>

                        </v-row>
                        <v-card-title>{{ time.statement_query }}</v-card-title>
                        <v-card-text>
                          {{ 'Attempted on' | translate }}{{ ': '+time.stored_at}}
                        </v-card-text>
                          <v-card-text class="text-center">
                              <v-btn class="white--text" :color="primary_color" small @click="details(courses.course_id, moduleindex, timeindex, time.statement_query)">{{ 'Details' | translate}}</v-btn>
                          </v-card-text>                        
                        </v-card>
                        <v-card
                          class="ma-4 pa-2"
                          width="220"
                          v-else
                        >
                        <v-card-title>{{ time.session_length}}</v-card-title>
                        <v-card-text>
                          <v-row>
                          <v-col cols="6">
                            {{ 'From' | translate }}<br />
                            {{ time.start_time }}
                          </v-col>
                          <v-col cols="6">
                            {{ 'To' | translate }}<br />
                            {{ time.end_time }}
                          </v-col>
                          </v-row>
                        </v-card-text>
                        </v-card>
                      </v-slide-item>
                    </v-slide-group>
                  </v-sheet>
                  <h3 v-else>{{ 'No data found' | translate }}</h3>
                </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
        </v-col>
      </v-row>
      </template>
      <template v-else-if="coursesdata.length == 0  && loadingdata==false">
          <v-row align="center"
              justify="center">
              <v-col><h2>{{ ( selectedCourses.length > 0  || selectedUsers.length > 0 ? 'No subscribed courses found'  :'Please subscribe to a course') | translate }}</h2></v-col>
          </v-row>
      </template>
    </v-container>
    <v-dialog v-model="dialog" max-width="800">
      <v-card>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <DataTable
                :title="quizdetailtitle"
                :headers="quizdetailheaders"
                :items="quizdetaildata"
                :search="quizdetailsearch"
                :footerstatus='footerstatus'
              />
            </v-col>
          </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary darken-1" text @click="dialog = false">{{ 'Close'| translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-content>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import {
  FETCH_DASHBOARD_DATA,
  FETCH_DASHBOARD_DOCUMENTS,
  FETCH_DASHBOARD_QUIZ_DATA,
  FETCH_TIME_DATA,
  FETCH_COURSES,
  FETCH_USERS,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type";
export default {
  name: "Dashboard",
  beforeRouteEnter(to, from, next) {
      store.dispatch(RESET_STATE)
      store.commit(SET_ROUTER_ENTER)
    if (store.state.auth.user.roles.includes(1)) {
      store.dispatch(FETCH_COURSES, '').then(resp => {
        if (resp.success) {
          store.commit(SET_LOADING, false);
        }
      });
      store.dispatch(FETCH_USERS, "").then(resp => {
        if (resp.success) {
          store.commit(SET_LOADING, false)
        }
      });
    }
    return next();
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable")
  },  
  computed: {
    ...mapGetters(["coursesdata","timesessiondata","dashboarddocuments", "users", "courses","currentUser","loadingdata"]),
  },
  created(){
    this.$store.commit(SET_LOADING, true)
  },  
  mounted(){
    this.getDashboardData();
    let company_meta  = JSON.parse(this.currentUser.company.company_meta)
    this.primary_color  = company_meta.primary_color
  },
  data: function() {
   return {
      openedDocumentPanel:[],
      openedPanel: {},
      selectedUsers: [],
      selectedCourses: [],
      primary_color: '',
      activeData:{},
      quizdetailsearch: "",
      footerstatus: 'false',
      quizdetailheaders: [],
      quizdetailtitle: 'Module details',
      dialog: false,   
      quizdetaildata: [], 

    };
  },
  methods: {
    async clearTime(courseindex,moduleindex,moduleid, course_id, userid,from,to){
      this.$refs[from][0].internalValue =''
      this.$refs[to][0].internalValue = ''
      this.getTime(courseindex,moduleindex,moduleid, course_id, userid,from,to)
    },
    async clearQuizData(courseindex,moduleindex,moduleid, course_id, userid,from,to){
      this.$refs[from][0].value =''
      this.$refs[to][0].value = ''
      this.getQuizData(courseindex,moduleindex,moduleid, course_id, userid,from,to)
    },
    async getTime(courseindex,moduleindex,moduleid, course_id, userid,from,to){
      await store.commit(SET_LOADING, true)
      this.activeData[course_id] = {}
      this.activeData[course_id][moduleindex] = 'time'      
      let fromdate = (this.$refs[from] == undefined ? '': (this.$refs[from][0].internalValue !=undefined ?this.$refs[from][0].internalValue:'' ))
      let todate = (this.$refs[to] == undefined ? '': (this.$refs[to][0].internalValue !=undefined ?this.$refs[to][0].internalValue:'' ))
      await this.$store.dispatch(FETCH_TIME_DATA,{moduleid: moduleid, moduleindex:moduleindex, course_id:course_id, userid:userid, fromdate:fromdate, todate:todate}).then(()=>{
        this.$store.commit(SET_LOADING, false)
        this.openPanel(courseindex,moduleindex)
      })
    },
    details(courseid,moduleindex,index, query) {
        if(query == 'attempted'){
          this.quizdetailheaders= [
            {text: this.$t("Your score"), value:'result.score.raw'},
            {text: this.$t("Max Score"), value:'result.score.max'},
            {text: this.$t("Time taken"), value:'result.seconds'},
            {text: this.$t("Pass Score"), value:'pass_score'},
          ]  
        }
        else{
          this.quizdetailheaders= [
            {text: this.$t("Your score"), value:'result.score.raw'},
            {text: this.$t("Max Score"), value:'result.score.max'},
            {text: this.$t("Time taken"), value:'result.seconds'},
            {text: this.$t("Status"), value:'statement_query'},
          ]   
        }
        this.quizdetaildata = [this.timesessiondata[courseid][moduleindex][index]]
        this.dialog = true
    },
    async getQuizData(courseindex,moduleindex,moduleid, course_id,userid,from,to){
      await store.commit(SET_LOADING, true)
      this.activeData[course_id] = {}
      this.activeData[course_id][moduleindex] = 'quiz'      
      let fromdate = (this.$refs[from] == undefined ? '': (this.$refs[from][0].internalValue !=undefined ?this.$refs[from][0].internalValue:'' ))
      let todate = (this.$refs[to] == undefined ? '': (this.$refs[to][0].internalValue !=undefined ?this.$refs[to][0].internalValue:'' ))
      await this.$store.dispatch(FETCH_DASHBOARD_QUIZ_DATA,{moduleid: moduleid, moduleindex:moduleindex, course_id:course_id, userid:userid, fromdate:fromdate, todate:todate}).then(()=>{
        this.$store.commit(SET_LOADING, false)
        this.openPanel(courseindex,moduleindex)
      })
    },    
    async getDashboardData(){
      this.openedDocumentPanel=[]
      this.openedPanel = {}
      this.activeData = {}
      await this.$store.dispatch(FETCH_DASHBOARD_DATA,'subscribed-courses?course_ids='+this.selectedCourses+'&user_ids='+this.selectedUsers).then(() => {
        this.$store.commit(SET_LOADING, false)
        let coursedatalength= this.coursesdata.length
        let i=0;
        while(i<coursedatalength){
          this.$set(this.openedPanel,i,[])
          i++;
        }
      })
    },
    openPanel(courseindex,moduleindex){
      if(this.openedPanel[courseindex].indexOf(moduleindex) == -1){
        this.openedPanel[courseindex].push(moduleindex)
      }
    },
    async openDocumentPanel(searchvalue,courseid){
      let searchdata = (this.$refs[searchvalue] == undefined ? '': (this.$refs[searchvalue][0].internalValue == undefined ? '' :this.$refs[searchvalue][0].internalValue))
      await this.$store.dispatch(FETCH_DASHBOARD_DOCUMENTS,{course_id: courseid, search: searchdata}).then(() => {
        this.$store.commit(SET_LOADING, false)
        if(this.openedDocumentPanel.indexOf(courseid) == -1){
          this.openedDocumentPanel.push(courseid)
        }
      })        
    },
    closePanel(courseindex,moduleindex,moduleid,courseid,userid){
      if(this.openedPanel[courseindex].indexOf(moduleindex) >=0){
        this.openedPanel[courseindex] = this.openedPanel[courseindex].filter(item => item!=moduleindex)
      }
      else{
        this.openPanel(courseindex,moduleindex)
        this.getTime(courseindex,moduleindex,moduleid, courseid, userid)
      }
    },
    play(id) {
      this.$router.push("/moduleplayer/" + id)
    },
  }
};
</script>
<style scoped>
@media (min-width: 300px) and (max-width: 960px) {
  .module-title{
    order:1;
  }
  .username{
    order:2;
  }
  .play-button{
    order:2;
  }
  .timespent{
    order:3;
  }
  .progress{
    order:4;
  }
}
</style>
